module.exports = __webpack_public_path__ + "img/2.ff1b1b84.jpg";